import React, { useEffect, useState } from 'react';
import GoPremiumCTA from './GoPremiumCTA';
import { useEntitlements } from '../../contexts/EntitlementsContext';
import { MD3Button, MD3Dialog, MD3DialogActions, useSnackbar } from '../Material3';
import { useNavigate } from 'react-router-dom';

const PremiumModal = () => {
  const [open, setOpen] = useState(false);
  const { isPremium } = useEntitlements();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    const onOpen = () => {
      setOpen(true);
      // Also surface a lightweight snackbar with a learn-more action
      try {
        showSnackbar({
          message: 'Premium unlocks AI and advanced features',
          variant: 'default',
          autoHideDuration: 5000,
          action: (
            <MD3Button variant="text" onClick={() => navigate('/premium')}>
              Learn more
            </MD3Button>
          )
        });
      } catch {
        // Silently ignore navigation errors
      }
    };
    window.addEventListener('openPremiumModal', onOpen);
    return () => window.removeEventListener('openPremiumModal', onOpen);
  }, [navigate, showSnackbar]);

  useEffect(() => {
    if (isPremium && open) setOpen(false);
  }, [isPremium, open]);

  return (
    <MD3Dialog
      open={open}
      onClose={() => setOpen(false)}
      title="ShelfQuest Premium"
      descriptionId="premium-modal-description"
      maxWidth="md"
    >
      <p id="premium-modal-description" className="md-body-medium text-on-surface-variant">
        Everything you need to read smarter.
      </p>
      <ul className="md-body-medium space-y-2 mb-4 list-disc pl-5">
        <li>AI summaries and contextual insights</li>
        <li>Advanced reading analytics and streaks</li>
        <li>Cross-device sync and secure backup</li>
        <li>Full-text note search and export</li>
        <li>Priority processing and new features first</li>
      </ul>
      <MD3DialogActions>
        <MD3Button variant="text" onClick={() => setOpen(false)}>Maybe later</MD3Button>
        <MD3Button variant="outlined" onClick={() => { setOpen(false); navigate('/premium'); }}>Learn more</MD3Button>
        <GoPremiumCTA size="large">Start Premium</GoPremiumCTA>
      </MD3DialogActions>
    </MD3Dialog>
  );
};

export default PremiumModal;
